<template>
  <div class="centerBody">
        <i class="bi bi-qr-code-scan" style="font-size: 120px;" @click="scanQrCode"></i> <br/>
        <span>点击上图扫用户出示的核销二维码</span>
  </div>
</template>

<style>
.centerBody{
  padding: 20%;
  border: 1px saddlebrown;
  text-align: center;
  height: 100vh;
  align-content: center;
}

</style>
  
<script>
import wx from 'jweixin-1.6.0';

export default {
  data () {
    return {
    }
  },
  mounted() {
    //this.scanQrCode();
  },
    components: {
    },
  methods: {    
    scanQrCode(){
      wx.scanQRCode({
        needResult: 0, 
        scanType: ["qrCode","barCode"], 
        success: function (res) {
          var result = res.resultStr; 
        }
      });
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/views/token_check.vue